import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  editButton: {
    id: 'course-authoring.course-updates.button.edit',
    defaultMessage: 'Edit',
  },
  deleteButton: {
    id: 'course-authoring.course-updates.button.delete',
    defaultMessage: 'Delete',
  },
  errorMessage: {
    id: 'course-authoring.course-updates.date-invalid',
    defaultMessage: 'Action required: Enter a valid date.',
  },
});

export default messages;
